module.exports = __webpack_public_path__ + "img/otc-black.007c6157.svg";